import React from 'react'
import eligibility from "./../../assets/eligibility-and-participant.webp";
import register from "./../../assets/register.webp";
import { FaArrowRight, FaUserShield, FaGraduationCap, FaFileAlt, FaCalendarAlt, FaCheckCircle, FaInfoCircle } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import './CapfRegistrationPage.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserShield } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import { Container } from 'reactstrap';

const CapfRegistrationPage = () => {
  const navigate = useNavigate();

  const handleProceedToRegistration = () => {
    sessionStorage.setItem('formType', 'CAPF');
    navigate('/register');
  };

  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faUserShield} className="me-2" />
            CAPF Registration
          </h3>
        </Container>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            
            {/* About Section */}
            <div className='info-card mt-1 mb-4 fade-in'>
              <div className='card-header-custom d-flex justify-content-between align-items-center'>
                <div className='d-flex align-items-center'>
                  <FaInfoCircle className='header-icon' />
                  <h3>About the Registration</h3>
                </div>
                <button onClick={handleProceedToRegistration} className='btn-header-custom ' style={{ padding: '8px 16px', minWidth: 'auto', width: 'fit-content' }}>
                  <span>Proceed to Registration</span>
                  <FaArrowRight className='ms-2' />
                </button>
              </div>
              <div className='card-body-custom'>
                <p className='lead-text'>
                  This registration form is exclusively for Ex-Central Armed Police Forces (CAPF) personnel who wish to apply for the specified program/opportunity.
                </p>
                <div className='alert alert-info d-flex align-items-center' role='alert'>
                  <FaCheckCircle className='me-2' />
                  <span>Persons fulfilling the eligibility requirements may continue with the registration.</span>
                </div>
              </div>
            </div>

            <div className='row g-4'>
              {/* Eligibility Criteria */}
              <div className='col-md-6'>
                <div className='feature-card h-100 eligibility-card'>
                  <div className='row'>
                    <div className='col-md-8'>
                      <div className='d-flex align-items-center mb-3'>
                        <div className='card-icon' data-step='1'>
                          <FaUserShield />
                        </div>
                        <h4 className='ms-3'>Eligibility Criteria</h4>
                      </div>
                      <ul className='custom-list'>
                        <li>Ex-CAPF personnel</li>
                        <li>Valid Aadhaar Number</li>
                        <li>Class 10th & 12th passed</li>
                        <li>Graduation Degree</li>
                        <li>Professional qualifications (if applicable)</li>
                      </ul>
                      
                    </div>
                    <div className='col-md-4 d-flex align-items-center justify-content-center'>
                      <img src={eligibility} alt="eligibility" className='img-fluid rounded' />
                    </div>
                    <div className='note-box'>
                        <small><strong>Note:</strong> Applications from non-CAPF personnel will not be considered.</small>
                      </div>
                  </div>
                </div>
              </div>

              {/* Who Can Apply */}
              <div className='col-md-6'>
                <div className='feature-card h-100 who-can-apply-card'>
                  <div className='d-flex align-items-center mb-3'>
                    <div className='card-icon' data-step='2'>
                      <FaCheckCircle />
                    </div>
                    <h4 className='ms-3'>Who Can Apply</h4>
                  </div>
                  <ul className='custom-list'>
                    <li>Former CAPF personnel</li>
                    <li>Completed service tenure</li>
                    <li>Officially discharged</li>
                    <li>NOK Of CAPF</li>
                   
                  </ul>
                  <img src={register} alt="register" className='img-fluid rounded register-image' />
                </div>
              </div>

              {/* Documents Required */}
              <div className='col-md-6'>
                <div className='feature-card h-100 documents-card'>
                  <div className='d-flex align-items-center mb-3'>
                    <div className='card-icon' data-step='3'>
                      <FaFileAlt />
                    </div>
                    <h4 className='ms-3'>Documents Required</h4>
                  </div>
                  <p className='text-muted mb-3'>Keep these documents ready:</p>
                  <ul className='custom-list'>
                    <li>Discharge Book</li>
                    <li>Experience Certificate(if Any)</li>
                    <li>Aadhaar Card</li>
                    <li>10th Marksheet / Certificate</li>
                    <li>12th Marksheet / Certificate</li>
                    <li>Graduation Marksheet / Degree</li>
                    <li>Professional Course Certificate</li>
                  </ul>
                  <div className='note-box'>
                    <small>All documents must be clear and legible.</small>
                  </div>
                </div>
              </div>

              {/* Application Process */}
              <div className='col-md-6'>
                <div className='feature-card h-100 process-card'>
                  <div className='d-flex align-items-center mb-3'>
                    <div className='card-icon' data-step='4'>
                      <FaGraduationCap />
                    </div>
                    <h4 className='ms-3'>Application Process</h4>
                  </div>
                  <ol className='process-steps'>
                    <li>Read instructions carefully</li>
                    <li>Click on Proceed to Registration</li>
                    <li>Enter personal and service details</li>
                    <li>Enter educational qualifications</li>
                    <li>Upload required documents</li>
                    <li>Review information</li>
                    <li>Submit application</li>
                  </ol>
                </div>
              </div>
            </div>

            {/* Important Dates */}
            <div className='dates-card mt-4'>
              <div className='card-header-custom'>
                <FaCalendarAlt className='header-icon' />
                <h3>Important Dates</h3>
              </div>
              <div className='card-body-custom'>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='date-item'>
                      <span className='date-label'>Registration Start Date:</span>
                      <span className='date-value'>To be announced</span>
                    </div>
                  </div>
                  {/* <div className='col-md-6'>
                    <div className='date-item'>
                      <span className='date-label'>Registration End:</span>
                      <span className='date-value'>To be announced</span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className='text-center mt-5'>
              <button 
                onClick={handleProceedToRegistration} 
                className='btn btn-primary-custom btn-sm'
                style={{ padding: '8px 16px', minWidth: 'auto', width: 'fit-content' }}
              >
                <span>Proceed to Registration</span>
                <FaArrowRight className='ms-2' />
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default CapfRegistrationPage